import { TrendingUp, Car, ParkingSquare, Clock } from "lucide-react";
import { impactStats } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";

const icons = [TrendingUp, Car, ParkingSquare, Clock];

export const Impact = () => (
  <section id="impact" data-testid="impact-section" className="relative py-28 bg-surface/40 border-t border-white/5">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal className="max-w-2xl">
        <Overline>Projected Real-World Impact</Overline>
        <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
          Real-time intelligence.<br /><span className="text-gradient">Real-world impact.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {impactStats.map((s, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={i} delay={i * 0.08}>
              <div className="group h-full rounded-2xl border border-white/10 bg-ink/70 p-7 hover:-translate-y-1 transition-transform" style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)" }}>
                <Icon className="h-6 w-6" style={{ color: s.color }} />
                <div className="mt-5 font-mono text-xs tracking-[0.15em] uppercase text-white/50">{s.label}</div>
                <div className="mt-1 font-heading font-extrabold text-3xl" style={{ color: s.color }}>{s.value}</div>
                <p className="mt-3 text-sm text-white/60">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <p className="mt-8 text-xs text-white/40">
        * Projections based on dynamic pricing models used across transportation and mobility sectors.
      </p>
    </div>
  </section>
);
